import React from 'react';
import PropTypes from 'prop-types';
import Radio from 'zignal-landscape/lib/Radio';
import Label from 'zignal-landscape/lib/Label';

import Styles from './DashboardSettingsModal.css';

const DashboardTemplateItem = ({
  children,
  templateType,
  checked,
  onChange
}) => {
  function handleChange() {
    onChange && onChange(templateType);
  }

  return (
    <div
      className={Styles.itemWrapper}
      onClick={handleChange}
      data-cy="dashboard-settings-template-item"
    >
      <div className={Styles.itemCheckboxWrapper}>
        <Radio
          id={`template-(${templateType.label})`}
          name="template-type"
          checked={checked || false}
          onChange={handleChange}
          data-cy="dashboard-settings-template-item-radio"
        />
      </div>
      <div className={Styles.itemDescriptionWrapper}>
        <Label>{templateType.label.toUpperCase()}</Label>
        <p>{templateType.description}</p>
        {children}
      </div>
      <div className={Styles.clearFix} />
    </div>
  );
};

DashboardTemplateItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  checked: PropTypes.bool,
  templateType: PropTypes.any,
  onChange: PropTypes.func
};

export default DashboardTemplateItem;
